// extracted by mini-css-extract-plugin
export default {"comment":"index_comment_OpDg-","commentTitle":"index_commentTitle_yZOd-","commentBox":"index_commentBox_ttfwY"};